import { LoaderFunction } from 'react-router-dom';

// Constants
import { formActionNaming } from '../../../../../components/forms/ActionForms/constants';

// Utils
import { decompressSessionStorage } from '../../../../../utils/sessionStorage';
import { claimDraftScope } from '../../../../../utils/draftOwnership';
import {
  ACTION_CREATION_SCOPE,
  ACTION_MEDIA_SCOPE,
  readCreationDraftId,
} from '../../../../../utils/draftScopes';
import { foreignCreationParentRedirect } from '../creationDraft';

export const LocationLoader: LoaderFunction | undefined = async ({ params, request }) => {
  // Un borrador de OTRO padre no se abre bajo esta URL: atrás, una URL
  // compartida o el «Editar» de un resumen viejo enseñaban — y guardaban — el
  // borrador de la OT Y bajo la de la X (auditoría de creación 2.3).
  const foreignParent = foreignCreationParentRedirect({ params, request });
  if (foreignParent) return foreignParent;
  // Las copias de las pestañas, la lista de fotos y el croquis son del
  // borrador en curso (`draftId`): si eran de otro, fuera, antes de que nadie
  // las lea. Síncrono y antes de cualquier `await`: el loader de `details` y el
  // de la pestaña corren en paralelo (spec 2026-11-02 wizard-draft-ownership).
  const draftId = readCreationDraftId();
  claimDraftScope(ACTION_CREATION_SCOPE, draftId);
  claimDraftScope(ACTION_MEDIA_SCOPE, draftId);

  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  const stringifyForm = sessionStorage.getItem(
    formActionNaming.NEW_LOCATION_FORM
  );

  const stringifyWorkOrderForm = sessionStorage.getItem(
    formActionNaming.NEW_ACTION_DATA
  );

  let parsedWorkOrderData;

  if (stringifyWorkOrderForm) {
    parsedWorkOrderData = JSON.parse(
      decompressSessionStorage(stringifyWorkOrderForm)
    );
  }

  let sessionStorageData;

  if (stringifyForm) {
    sessionStorageData = JSON.parse(decompressSessionStorage(stringifyForm));
  }

  const combinedData = {
    ...parsedWorkOrderData,
    ...sessionStorageData,
    breadCrumbsData: {
      orderParentRoid: parsedWorkOrderData?.orderParentRoid,
      orderParentId: parsedWorkOrderData?.orderParentId,
    },
  };

  return combinedData;
};

  return { data: load() };
};
